import styled from 'styled-components';
import DocumentsFunnel from './DocumentsFunnel';
import { colorSchema, media } from 'utils/style';

export default styled(DocumentsFunnel)`
  margin: 0 -1.6rem;
  ${media.greaterThan('tablet')`
    margin: 0;
  `}

  .documents-funnel {
    display: flex;
    width: 100%;

    &__step {
      align-items: center;
      border: 0;
      border-bottom-style: solid;
      border-bottom-width: 7px;
      border-bottom-color: ${colorSchema('grey300')};
      cursor: pointer;
      display: flex;
      background: none;
      flex-basis: 50%;
      flex-direction: column;
      justify-content: center;
      padding: 1.6rem 0 0.8rem 0;

      &--is-active {
        border-bottom-color: ${colorSchema('primary500')};

        .documents-funnel__step-title,
        .documents-funnel__step-number {
          color: ${colorSchema('grey900')};
        }
      }
    }

    &__step-number,
    &__step-title {
      color: ${colorSchema('grey500')};
      font-weight: bold;
    }

    &__step-number {
      text-transform: uppercase;
    }
  }
`;
